<template>
  <view class="es-content">
    <view class="es-content__box es-content__card">
      <es-card custom-body="es-content__miniapp_card_body">
        <view wx:for="{{registerContentData}}">
          <component
            is="{{item.component}}"
            isShow="{{item.isShow}}"
            item="{{item}}"
            wx:model="{{baseData[item.name]}}"
            isRequiredShow="{{isRequiredShow}}"
            selectedCardList="{{selectedCardList}}"
            isNeedCard="{{isNeedCard}}"
            cardType="{{cardType}}"
            baseData="{{baseData}}"
          />
        </view>
      </es-card>
    </view>
  </view>
  <!-- 弹窗部分 -->
	<!-- <es-dialog
		showCancelButton
		showConfirmButton
		title="温馨提示"
		show="{{showDialog}}"
		algin="left"
		
	>
		<view slot="content">{{ dialogText }}</view>
	</es-dialog> -->
  <successDialog 
    show="{{showDialog}}" 
    account="{{nickname}}" 
    password="{{password}}" 
    bind:confirm="gotologin"/>
  <failDialog 
    show="{{showFailDialog}}" 
    bind:confirm="gocurrent"
    msg="{{failmsg}}"/>
</template>


<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { bridge } from '@didi/webx-js'
  import { isDdPassengerH5, isALIMini } from '@/common/constant'
  import { innerRouter, pagePath } from "@/common/jump";
  import {
    registerConfig,
    componentsConfig
  } from '@/config/register/index'
  import { getRegisterAction12306 } from "@/api/login12306";
  import { LOAD_FAIL_CONTENT } from "@/common/constant";
  import { AES_ECB_ENCRYPT } from '@/common/crypto'
  import { RSA2_ENCRYPT } from '@/common/rsa_crypto'
  import { hasRequired, permitValidateConf } from '@/utils'
  import Validator from '@/utils/validator'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { trackEvent } from '@/common/track'
  const baseArr =[
    'passenger_name', 'sex', 
    'card_type', 'id_no', 'nationlity',
    'born_date','encrypt_phone','expire_date',
    'nickname','password','confirm_password','email'
  ] //基础数据 

  createComponent({
    data()  {
      let baseData = {}
      let temp = baseArr.map((item) => {
        if (item === 'nationlity') {
          baseData[item] = {}
        } else if(item === 'card_type'){
          baseData[item] = [{
            code: "1",
            card_type: "1",
            name: "二代身份证",
            card_name: "二代身份证",
          }]
        }else {
          baseData[item] = ''
        }
      })
      return {
        registerContentData: {},
        isRequiredShow: false,
        isNeedCard: true,
        baseData,
        showDialog:false,
        showFailDialog:false,
        failmsg:""
      }

    },
    props:{
      isAgree: Boolean, // 协议授权
    },
    computed: {
      nickname(){
        return this.baseData?.nickname
      },
      password(){
        return this.baseData?.password
      },
      selectedCardList(){ // 选中的证件类型
        return this.baseData.card_type? this.baseData.card_type:[]
      },
      cardType(){
        return this.baseData?.card_type[0] || {
          code: "1",
          card_type: "1",
          name: "二代身份证",
          card_name: "二代身份证",
        }
      }
    },
     watch: {
      'baseData.card_type': {
        immediate: true,
        deep: true,
        handler(val) {
          this.baseData.id_no = '' 
          this.baseData.expire_date = '2033-01-01' 
          this.baseData.born_date = '2000-01-01' 
          this.baseData.nationlity = {
            country_code: "CN",
            country_name_cn: "中国"
          } 
        }
      }
    },
    methods: {
      init(){
        baseArr.map((item) => {
          registerConfig[item] &&
            (this.registerContentData[item] = {
              ...registerConfig[item],
              component: componentsConfig[item],
              name: item
            })
        })
        this.$forceUpdate()
      },
      gotologin(){
        innerRouter.goback()
      },
      gocurrent(){
        this.showFailDialog = false
      },
      validateNext(){
        console.log('this.base=====>', this.baseData)
        const NULLREG = '^[sS]*.*[^s][sS]*$'
        var validator = new Validator()
        const _registerConfig= registerConfig
        if(['B','H','6','G'].includes(this.cardType.code)){
          _registerConfig['sex'].isRequired = true
        }
        baseArr.forEach((key) => {
          let itemConfig = _registerConfig[key]
          let isRequired = hasRequired(
            itemConfig.requiredcCrdTypes,
            this.selectedCardList,
            itemConfig.isRequired,
            this.isNeedCard
          )
          // 空校验
          if (isRequired) {
            validator.cbAdd(this.baseData[key], NULLREG, itemConfig.toastNullTips)
          }
          // 格式校验
          if (isRequired) {
            validator.cbAdd(this.baseData[key], itemConfig.validator, itemConfig.toastTips)
          }

        })
        var errorMsg = validator.start()
        if(!errorMsg){
          errorMsg = this.baseData.password === this.baseData.confirm_password? '':'请确认密码是否相同'
        }
        return errorMsg
      },
      makeData() {
        console.error('makeData',this.baseData);
        const {
          passenger_name,
          sex,
          card_type,
          id_no,
          nationlity,
          born_date,
          encrypt_phone,
          expire_date,
          nickname,
          password,
          confirm_password,
          email
        } = this.baseData

        console.error('card_type is',card_type,card_type[0]?.card_type);
        const data = {
          passenger_name_encrypt: AES_ECB_ENCRYPT(passenger_name),
          sex,
          id_type: card_type[0]?.card_type,
          id_no_encrypt: AES_ECB_ENCRYPT(id_no),
          born_date,
          mobile_no_encrypt: AES_ECB_ENCRYPT(encrypt_phone),
          valid_date_end:expire_date,
          account_number:RSA2_ENCRYPT(nickname),
          password:RSA2_ENCRYPT(password),
          confirm_password:RSA2_ENCRYPT(confirm_password),
          email,
          passenger_type: "11"
        }
        if(card_type[0]?.card_type === '1' || card_type[0]?.card_type === '2'){
          delete data.valid_date_end
          delete data.born_date
          delete data.sex
        }
        if(card_type[0]?.card_type === 'B'){
          data.country_code = nationlity?.country_code
        }
        return data
      },
      submit(options){
        getRegisterAction12306(options).then((res) => {
           mpx.hideLoading();
           console.error(res);
           const { data, code, success, message } = res;
           if (success) {
            if (code === "0") {
              // 注册成功 需要核验
              // this.showDialog = true
              innerRouter.push(pagePath().VERIFICATIONCODE,{
                from:'register',
                phone: this.baseData?.encrypt_phone,
                nickname:this.nickname,
                password:this.password,
              });
            } else {
               // 注册失败 弹窗提示
              this.showFailDialog = true
              this.failmsg = message
            }
          } else {
            mpx.showToast({
              title: LOAD_FAIL_CONTENT, //提示的内容,
              icon: "error", //图标,
              duration: 2000, //延迟时间,
            });
          }

        })
        console.error('submit');
      },
      async save() {
        const errMsg = this.validateNext()
        if (errMsg) {
          trackEvent('userteam_train_regpage_next_ck', 'UT-火车票-注册页面-下一步-点击',{
            is_success:0
          })
          mpx.showToast({
            title: errMsg, //提示的内容,
            icon: "error", //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {},
          });
          return
        }
        
        if (!this.isAgree) {
          trackEvent('userteam_train_regpage_next_ck', 'UT-火车票-注册页面-下一步-点击',{
            is_success:0
          })
          mpx.showToast({
            title: '请先阅读并同意下方授权内容', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
            success: (res) => {}
          })
          return
        }
        trackEvent('userteam_train_regpage_next_ck', 'UT-火车票-注册页面-下一步-点击',{
          is_success:1
        })
        const data = this.makeData()
        await this.submit(data)
      },

    },
    mounted() {
      this.init()
    }
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    /deep/ .mpx-picker-panel
      border-radius 10px
    /deep/ .mpx-input
      outline none
      background none
      box-shadow none
      -webkit-tap-highlight-color rgba(255,0,0,0)
    /deep/ .es-content__name
      margin-right 0
      width 74px
    /deep/ .es-content__name-field
      width 100%
    /deep/ .es-field
      width 100%  
    /deep/ .es-content__name-text-border
      width calc(100% - 80px)
      right 10px
    +e('box')
      margin 12px
      position relative
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .item-style
        margin-bottom 0
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid rgba(235, 237, 240, 0.6)
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        // &::after
        // border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color #333333 !important
    // 小程序用
    +e('miniapp_card_header')
      line-height 38px
      font-size 16px
      font-weight bold
      margin 4px 12px
      padding 0
    // 小程序用
    +e('miniapp_card_body')
      padding 0 12px
    // 小程序用
    +e('tip-text')
      color #999999
      font-size 12px
      text-align justify
    +e('tips-icon')
      font-size 12px
      line-height 17px
      margin-right 3px
      color #999999
    +e('name-tips')
      display flex
      justify-content space-between
      align-items center
      margin -4px -12px 0 -12px
      padding 0 12px
      height 32px
      background-image linear-gradient(270deg, #FFFFFF 0%, #FFF4EE 100%)
    +e('name-tips-content')
      font-family PingFangSC-Regular
      font-size 12px
      color #FF6221
    +e('name-tips-entrance')
      display flex
      align-items center
      font-family PingFangSC-Regular
      font-size 12px
      color #666666
      text-align right
      line-height 12px
    +e('change')
      position absolute
      z-index 1
      top 80px
      right 12px

</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-card': '@didi/es-mpx-ui/lib/card',
      'es-contact-name': '@/pages/contact/components/content/components/contact-name12306',
      'es-contact-type': '@/pages/contact/components/content/components/contact-type',
      'es-contact-phone': '@/pages/contact/components/content/components/contact-phone12306',
      'es-english-surname': '@/pages/contact/components/content/components/english-surname',
      'es-english-name': '@/pages/contact/components/content/components/english-name',
      'es-birth-date': '@/pages/contact/components/content/components/birth-date',
      'es-expire-date': '@/pages/contact/components/content/components/expire-date',
      'es-contact-sex': '@/pages/contact/components/content/components/contact-sex',
      'es-contact-nickname12306': '@/pages/contact/components/content/components/contact-nickname12306',
      'es-contact-remark': '@/pages/contact/components/content/components/contact-remark',
      'es-nationlity': '@/pages/contact/components/content/components/nationlity12306',
      'es-card-list': '@/pages/contact/components/content/components/card-list',
      'es-save-switch': '@/pages/contact/components/content/components/save-switch',
      'es-tip-text': '@/pages/contact/components/content/components/tip-text',
      'es-change-btn': '@/pages/contact/components/content/components/change-btn',
      'es-password': '@/pages/contact/components/content/components/password',
      'es-confirm-password': '@/pages/contact/components/content/components/confirm-password',
      'es-email': '@/pages/contact/components/content/components/email',
      "es-id-no":'@/pages/contact/components/content/components/id-no',
      "es-card-type":'@/pages/contact/components/content/components/card-type',
      "successDialog":"./success-dialog",
      "failDialog":"./fail-dialog"
    }
  }
</script>